import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dropdown } from "primereact/dropdown";
import { RadioButton } from "primereact/radiobutton";
import { classNames } from "primereact/utils";
import { useContext, useEffect, useRef, useState, useMemo } from "react";
import { Controller, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useNavigate, useOutletContext } from "react-router-dom";
import PrimeConfirmDialog from "../../components/dialog/PrimeConfirmDialog";
import PrimeDialog from "../../components/dialog/PrimeDialog";
import ImageLocaleModal from "../../components/ImageLocaleModal";
import NoInfo from "../../components/NoInfo";
import PrimeTableFooter from "../../components/PrimeTableFooter";
import { useEditableFlag } from "../../hooks/useEditableFlag";
import { SystemLoading, checkLoading } from "../../store/loadingStore";
import { MessageContext, handleSuccessMessage } from "../../store/messageStore";
import { updateFeUsers2Info } from "../../utility/service/account-service";
import { AlertService } from "../../utility/service/alert-service";
import { handleFileDownloadRes } from "../../utility/service/api-base";
import { getSubItemsByItemNo } from "../../utility/service/api-service";
import {
  checkImportantIndetificationItem,
  copyPlanSn,
  createInventoryExportTask,
  deleteCarbonPlan,
  downloadInventoryExportTaskFile,
  getCarbonPlanList,
  getCompanyPlaceList,
  queryCopyPlanSnBatch,
  queryInventoryExportTaskStatus,
} from "../../utility/service/carbon-service";
import { parseTabPermissions } from "../../utility/service/tab-permission-utils";
import {
  Base64Encoder,
  BcryptEncoder,
  checkDpSuccess,
  getCompanyType,
  getFormErrorMessage,
  getCurrentLocale,
  isNotBlank,
  encoder,
} from "../../utility/service/tool-service";
import { AcctContext } from "../../utility/useReduce/userNameReduce";
import AddCopyPlanSn from "./components/AddCopyPlanSn";
import ConsolidateList from "./components/ConsolidateList";

export default function Carbon_Index() {
  const DEFAULT_EXPORT_MAX_RETRY = 120;
  const DEFAULT_EXPORT_INTERVAL_MS = 5000;
  const placeListLimit = 3;
  const { t } = useTranslation();
  const navigate = useNavigate();
  const isEditable = useEditableFlag("F10103"); // control edit by F10103
  const [, loading] = useContext(SystemLoading);
  const [, dispatch] = useContext(MessageContext); //訊息視窗
  const [state, dispatchUser] = useContext(AcctContext); //訊息視窗
  const {
    itemObj,
    setItemObj,
    filterParams,
    setFilterParams,
    setAction,
    setTab1Action,
    setReportListObj,
    flowStep,
    setFlowStep,
  } = useOutletContext();
  // 下拉
  const [planYearList, setPlanYearList] = useState([]); //盤查年度
  const [planTypeList, setPlanTypeList] = useState([]); //清冊類型
  const [companyPlaceList, setCompanyPlaceList] = useState([]);
  const [placeList, setPlaceList] = useState([]);
  // Tab 權限控制
  const [accessibleTabs, setAccessibleTabs] = useState([]);
  // 表格資料
  const [rowData, setRowData] = useState([]);
  const [lastDataSeq, setLastDataSeq] = useState(""); //分頁用key
  const [expandedRows, setExpandedRows] = useState({});
  // 刪除
  const [delObj, setDelObj] = useState({});
  const [delExpanded, setDelExpanded] = useState(false);
  const [delDialog, setDelDialog] = useState(false);
  // 重大性鑑別
  const [importantDialog, setImportantDialog] = useState(false);
  const [confirmAction, setConfirmAction] = useState(false);
  // 合併
  const [consolidatedDialog, setConsolidatedDialog] = useState(false);
  const [selPlan, setSelPlan] = useState(null);
  // 複製
  const [copyPlanDialog, setCopyPlanDialog] = useState(false);
  // 清冊
  const [templateDialog, setTemplateDialog] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  // 流程圖
  const [flowDialog, setFlowDialog] = useState(false);
  const [flowCheck, setFlowCheck] = useState(false);
  // 盤查上限
  const [createButtonFlag, setCreateButtonFlag] = useState(false);
  const [limitDialog, setLimitDialog] = useState(false);
  // 排程報告書
  const [batchPlanSnList, setBatchPlanSnList] = useState([]);
  // 清冊匯出排程
  const exportPollingRef = useRef(null);

  const {
    reset,
    handleSubmit,
    watch,
    getValues,
    setValue,
    control,
    formState: { errors, isValid, isDirty },
  } = useForm({
    defaultValues: {},
    //錯誤驗證時機
    mode: "all",
  });

  const cols = useMemo(
    () => [
      { field: "displayYear", header: t("queryYear") },
      { field: "planTypeName", header: t("planType") },
      { field: "displayCriterion", header: t("standard_basis") },
      { field: "displayCause", header: t("inventory_reason") },
      {
        header: " ",
        body: (rowData, rowIndex) => collapseButtonBody(rowData),
        style: { width: "2rem" },
      },
      {
        field: "placeName",
        header: t("place"),
        body: (rowData, rowIndex) => rawExpandBody(rowData, rowIndex),
      },
      { field: "displayGwp", header: "GWP" },
    ],
    [t, expandedRows],
  );

  useEffect(() => {
    Promise.all([axios_getSubItemsByItemNo("CFV_PLAN_YEAR", 0), axios_getSubItemsByItemNo("INVENTORY_TYPE", 42)]).then(
      ([yearList, typeList]) => {
        setPlanYearList(yearList);
        setPlanTypeList(typeList);
        axios_getCompanyPlaceList(yearList, typeList);
      },
    );
    setFlowStep(-1);
  }, []);

  // 頁面進入時直接顯示流程圖
  useEffect(() => {
    // 檢查是否是從子頁面返回
    const isFromChildPage = sessionStorage.getItem("fromCarbonChildPage");
    const userWantsToSeeModal = state?.dontShowAgain === "N";
    if (!isFromChildPage) {
      setFlowDialog(userWantsToSeeModal);
    }
    setFlowCheck(!userWantsToSeeModal);
    // 清除標記
    sessionStorage.removeItem("fromCarbonChildPage");
  }, []);

  // 組織邊界廠商清單
  const axios_getCompanyPlaceList = (yearList, typeList) => {
    checkLoading(loading);
    getCompanyPlaceList()
      .then((res) => {
        if (checkDpSuccess(res)) {
          const data = res.data.RespBody.companyPlaceList;
          setCompanyPlaceList(data);

          // 從子畫面回來（兩種身份都適用）
          if (filterParams?.companySeq) {
            Object.entries(filterParams).forEach(([key, value]) => {
              if (isNotBlank(value)) {
                setValue(key, value, { shouldValidate: true });
              }
            });

            // 還原 placeList
            const companyData = data.find((item) => item.companySeq === filterParams.companySeq);
            setPlaceList(companyData?.placeList);
            setCreateButtonFlag(companyData?.createButtonFlag);

            const reqBody = {
              companySeq: filterParams.companySeq,
              placeSeq: filterParams.placeSeq,
              startYear: encoder(yearList, filterParams.startYear),
              endYear: encoder(yearList, filterParams.endYear),
              planType: encoder(typeList, filterParams.planType),
            };

            axios_getCarbonPlanList(reqBody);
            return;
          }

          // 組織身份：自動帶入第一筆查詢
          if (getCompanyType() === "A") {
            const companyData = data[0];
            setValue("companySeq", companyData?.companySeq, { shouldValidate: true });
            setItemObj({ companyName: companyData?.companyName });
            setPlaceList(companyData?.placeList);
            setCreateButtonFlag(companyData?.createButtonFlag);
            axios_getCarbonPlanList({ companySeq: companyData?.companySeq });
            setFilterParams((prev) => ({
              ...prev,
              companySeq: companyData?.companySeq,
            }));
          }
        }
      })
      .finally(() => {
        checkLoading(loading, false);
      });
  };

  // 查詢下拉選單
  const axios_getSubItemsByItemNo = (itemNo, orderNo) => {
    return getSubItemsByItemNo(itemNo, orderNo).then((res) => {
      if (checkDpSuccess(res)) {
        let data = res.data.RespBody.subItems;
        return data.map((item, index) => ({
          ...item,
          index,
        }));
      }
      return [];
    });
  };

  // 載入 tab 權限
  useEffect(() => {
    const tabPermissions = state?.tabPermissions?.["F10103"];
    if (tabPermissions) {
      const parsedTabs = parseTabPermissions(tabPermissions);
      setAccessibleTabs(parsedTabs);
    } else {
      // 如果沒有權限設定，設為空陣列（無任何權限）
      setAccessibleTabs([]);
    }
  }, [state?.tabPermissions]);

  useEffect(() => {
    if (batchPlanSnList.length === 0) return;

    const interval = setInterval(() => {
      queryCopyPlanSnBatch({
        planSnList: batchPlanSnList.map((item) => item.planSn),
      }).then((res) => {
        if (checkDpSuccess(res)) {
          let data = res.data.RespBody.planList || [];
          const filterPlanSn = data.filter((item) => item.status !== "P" && item.status !== "L");
          const map = new Map(filterPlanSn.map((item) => [item.planSn, item]));
          setBatchPlanSnList((prev) => {
            return prev.filter((item) => !map.has(item.planSn));
          });
          setRowData((prev) => {
            return prev.map((item) => {
              const matched = map.get(item.planSn);
              if (matched) {
                return {
                  ...item,
                  batchStatus: matched.status,
                  batchMemo: matched.memo,
                };
              }
              return item;
            });
          });
        }
      });
    }, 10000);

    return () => clearInterval(interval);
  }, [batchPlanSnList]);

  useEffect(() => {
    return () => {
      if (exportPollingRef.current) {
        clearTimeout(exportPollingRef.current);
        exportPollingRef.current = null;
      }
    };
  }, []);

  const buildSearchReqBody = () => ({
    companySeq: getValues("companySeq"),
    placeSeq: getValues("placeSeq"),
    startYear: encoder(planYearList, getValues("startYear")),
    endYear: encoder(planYearList, getValues("endYear")),
    planType: encoder(planTypeList, getValues("planType")),
  });

  // 檢查特定 tab 是否有權限
  const hasTabPermission = (tabName) => {
    return accessibleTabs.includes(tabName);
  };

  // 確認刪除
  const confirmDel = () => {
    const reqBody = {
      planSn: delObj.planSn,
    };
    checkLoading(loading);
    deleteCarbonPlan(reqBody)
      .then((res) => {
        if (checkDpSuccess(res)) {
          setDelDialog(false);
          handleSuccessMessage(dispatch, t("button.delete") + " " + t("message.success"));
          axios_getCarbonPlanList(buildSearchReqBody());
        }
      })
      .finally((fin) => {
        checkLoading(loading, false);
      });
  };

  const goItemPage = (rowData = {}, action) => {
    rowData.companySeq = getValues("companySeq");
    setItemObj(rowData);
    setAction(action);
    setTab1Action(action);
    navigate(action, { state: { companyName: rowData?.companyName } });
  };

  // 複製
  const copyItem = (rowData) => {
    setItemObj(rowData);
    setAction("copy");
    setCopyPlanDialog(true);
  };

  // 刪除
  const deleteItem = (rowData) => {
    setDelObj(rowData);
    setDelExpanded(false);
    setDelDialog(true);
  };

  // 通用/製造清冊匯出
  const commonExportBodyTemplate = () => {
    return (
      <div className="flex flex-column gap-3">
        <div className="flex align-items-center">
          <RadioButton
            inputId="template1"
            name="template"
            value="template1"
            onChange={(e) => setSelectedTemplate(e.value)}
            checked={selectedTemplate === "template1"}
          />
          <label htmlFor="template1" className="ml-2">
            {t("溫室氣體盤查表單3.0.0版(修)")}
          </label>
        </div>
        <div className="flex align-items-center">
          <RadioButton
            inputId="template3"
            name="template"
            value="template3"
            onChange={(e) => setSelectedTemplate(e.value)}
            checked={selectedTemplate === "template3"}
          />
          <label htmlFor="template3" className="ml-2">
            {t("溫室氣體盤查表單3.0.0版(修)【含公式】")}
          </label>
        </div>
        <div className="flex align-items-center">
          <RadioButton
            inputId="template2"
            name="template"
            value="template2"
            onChange={(e) => setSelectedTemplate(e.value)}
            checked={selectedTemplate === "template2"}
          />
          <label htmlFor="template2" className="ml-2">
            {t("溫室氣體排放量清冊表單")}
          </label>
        </div>
        <div className="flex align-items-center">
          <RadioButton
            inputId="template4"
            name="template"
            value="template4"
            onChange={(e) => setSelectedTemplate(e.value)}
            checked={selectedTemplate === "template4"}
          />
          <label htmlFor="template4" className="ml-2">
            {t("溫室氣體排放量清冊表單【含公式】")}
          </label>
        </div>
      </div>
    );
  };

  // 各行業別清冊匯出
  const industrialExportBodyTemplate = (planTypeName) => {
    return (
      <div className="flex flex-column gap-3">
        <div className="flex align-items-center">
          <RadioButton
            inputId="template5"
            name="template"
            value="template5"
            onChange={(e) => setSelectedTemplate(e.value)}
            checked={selectedTemplate === "template5"}
          />
          <label htmlFor="template5" className="ml-2">
            {t(`${planTypeName ? `【${planTypeName}】` : ""}溫室氣體排放量清冊表單`)}
          </label>
        </div>
        <div className="flex align-items-center">
          <RadioButton
            inputId="template5_import"
            name="template"
            value="template5_import"
            onChange={(e) => setSelectedTemplate(e.value)}
            checked={selectedTemplate === "template5_import"}
          />
          <label htmlFor="template5_import" className="ml-2">
            {t(`${planTypeName ? `【${planTypeName}】` : ""}事業溫室氣體排放量資訊平台匯入表單`)}
          </label>
        </div>
      </div>
    );
  };

  // 匯出清冊前檢核重大性鑑別
  const handleExportItem = (rowData) => {
    setItemObj(rowData);
    // 若有重大性鑑別，先調用 API 檢查
    if (rowData?.importanceIdentification === "Y") {
      axios_checkImportantIndetificationItem(rowData?.planSn).then((showDialog) => {
        if (showDialog) {
          // 如果需要顯示對話框，則開啟對話框
          setImportantDialog(true);
        } else {
          setTemplateDialog(true);
        }
      });
    } else {
      setTemplateDialog(true);
    }
  };

  const stopExportPolling = () => {
    if (exportPollingRef.current) {
      clearTimeout(exportPollingRef.current);
      exportPollingRef.current = null;
    }
  };

  const closeExportingFlow = () => {
    stopExportPolling();
    checkLoading(loading, false);
  };

  const getClassByCriterion = (criterion) => {
    if (criterion === "0") return "S";
    if (criterion === "9") return "G";
    return "C";
  };

  const getExportFileName = (rowData) => {
    return `${rowData?.planTypeName}_${rowData?.year}_${rowData?.displayCause}_${rowData?.companyName}${
      rowData?.placeName ? `_${rowData?.placeName?.join(", ")}` : ""
    }.xlsx`;
  };

  const downloadExportFile = (rowData, taskSeq) => {
    checkLoading(loading, true, t("inventoryExport.processing"));
    downloadInventoryExportTaskFile({ taskSeq })
      .then((res) => {
        if (res?.status === 200) {
          handleFileDownloadRes(res, getExportFileName(rowData));
        } else {
          AlertService.ok(res?.data?.ResHeader?.rtnCode, res?.data?.ResHeader?.rtnMsg);
        }
      })
      .finally(() => {
        closeExportingFlow();
      });
  };

  const createConsolidatedExportFileName = () => {
    return `${selPlan?.[0]?.year}_${selPlan?.[0]?.companyName}_${t("button.consolidatedList")}.xlsx`;
  };

  const resolveExportPollingConfig = (respBody) => {
    const maxRetry = Number(respBody?.pollingMaxRetry);
    const intervalSeconds = Number(respBody?.pollingIntervalSeconds);

    return {
      maxRetry: Number.isInteger(maxRetry) && maxRetry > 0 ? maxRetry : DEFAULT_EXPORT_MAX_RETRY,
      intervalMs:
        Number.isInteger(intervalSeconds) && intervalSeconds > 0 ? intervalSeconds * 1000 : DEFAULT_EXPORT_INTERVAL_MS,
    };
  };

  const pollExportStatus = (taskSeq, rowData, pollingConfig, retry = 0) => {
    // 最多輪詢 10 分鐘，避免永久卡住。
    if (retry > pollingConfig.maxRetry) {
      closeExportingFlow();
      AlertService.ok("TIMEOUT", t("inventoryExport.timeout"));
      return;
    }

    queryInventoryExportTaskStatus({ taskSeqList: [taskSeq] })
      .then((res) => {
        if (!checkDpSuccess(res)) {
          throw new Error("queryInventoryExportTaskStatus failed");
        }

        const result = res?.data?.RespBody?.taskList?.find((item) => item.taskSeq === taskSeq);
        if (!result) {
          exportPollingRef.current = setTimeout(() => {
            pollExportStatus(taskSeq, rowData, pollingConfig, retry + 1);
          }, pollingConfig.intervalMs);
          return;
        }

        if (result.status === "E") {
          downloadExportFile(rowData, taskSeq);
          return;
        }

        if (result.status === "X") {
          closeExportingFlow();
          AlertService.ok("ERROR", result.memo || t("inventoryExport.failed"));
          return;
        }

        exportPollingRef.current = setTimeout(() => {
          pollExportStatus(taskSeq, rowData, pollingConfig, retry + 1);
        }, pollingConfig.intervalMs);
      })
      .catch(() => {
        closeExportingFlow();
        AlertService.ok("ERROR", t("inventoryExport.statusError"));
      });
  };

  const pollConsolidatedExportStatus = (taskSeq, fileName, pollingConfig, retry = 0) => {
    if (retry > pollingConfig.maxRetry) {
      closeExportingFlow();
      AlertService.ok("TIMEOUT", t("inventoryExport.timeout"));
      return;
    }

    queryInventoryExportTaskStatus({ taskSeqList: [taskSeq] })
      .then((res) => {
        if (!checkDpSuccess(res)) {
          throw new Error("queryInventoryExportTaskStatus failed");
        }
        const result = res?.data?.RespBody?.taskList?.find((item) => item.taskSeq === taskSeq);
        if (!result) {
          exportPollingRef.current = setTimeout(() => {
            pollConsolidatedExportStatus(taskSeq, fileName, pollingConfig, retry + 1);
          }, pollingConfig.intervalMs);
          return;
        }

        if (result.status === "E") {
          checkLoading(loading, true, t("inventoryExport.processing"));
          downloadInventoryExportTaskFile({ taskSeq })
            .then((downloadRes) => {
              if (downloadRes?.status === 200) {
                handleFileDownloadRes(downloadRes, fileName);
                setSelPlan(null);
                setConsolidatedDialog(false);
              } else {
                AlertService.ok(downloadRes?.data?.ResHeader?.rtnCode, downloadRes?.data?.ResHeader?.rtnMsg);
              }
            })
            .finally(() => {
              closeExportingFlow();
            });
          return;
        }

        if (result.status === "X") {
          closeExportingFlow();
          AlertService.ok("ERROR", result.memo || t("inventoryExport.failed"));
          return;
        }

        exportPollingRef.current = setTimeout(() => {
          pollConsolidatedExportStatus(taskSeq, fileName, pollingConfig, retry + 1);
        }, pollingConfig.intervalMs);
      })
      .catch(() => {
        closeExportingFlow();
        AlertService.ok("ERROR", t("inventoryExport.statusError"));
      });
  };

  // 匯出清冊（改為非同步排程）
  const exportItem = (rowData, templateType) => {
    let keepLoadingForPolling = false;
    checkLoading(loading);
    const reqBody = {
      planSn: rowData?.planSn,
      class: getClassByCriterion(rowData?.criterion),
      templateType,
    };

    switch (templateType) {
      case "template1":
      case "template2":
      case "template3":
      case "template4":
        break;
      case "template5":
        reqBody.type = rowData?.planType;
        break;
      case "template5_import":
        reqBody.type = `${rowData?.planType}_import`;
        break;
      default:
        AlertService.ok("ERROR", t("inventoryExport.unknownTemplate"));
        checkLoading(loading, false);
        return;
    }

    createInventoryExportTask(reqBody)
      .then((res) => {
        if (!checkDpSuccess(res)) return;

        const taskSeq = res?.data?.RespBody?.taskSeq;
        if (!taskSeq) {
          AlertService.ok("ERROR", t("inventoryExport.createError"));
          return;
        }

        const pollingConfig = resolveExportPollingConfig(res?.data?.RespBody);
        keepLoadingForPolling = true;
        checkLoading(loading, true, t("inventoryExport.processing"));
        pollExportStatus(taskSeq, rowData, pollingConfig);
      })
      .finally(() => {
        if (!keepLoadingForPolling) {
          checkLoading(loading, false);
        }
      });
  };

  // 匯出合併清冊
  const exportMultiItem = () => {
    let keepLoadingForPolling = false;
    let planSnArray = selPlan?.map((item) => item.planSn);
    checkLoading(loading);
    createInventoryExportTask({
      planSn: planSnArray.toString(),
      class: "S",
      templateType: "template1",
    })
      .then((res) => {
        if (!checkDpSuccess(res)) return;

        const taskSeq = res?.data?.RespBody?.taskSeq;
        if (!taskSeq) {
          AlertService.ok("ERROR", t("inventoryExport.createError"));
          return;
        }

        const pollingConfig = resolveExportPollingConfig(res?.data?.RespBody);
        keepLoadingForPolling = true;
        checkLoading(loading, true, t("inventoryExport.processing"));
        pollConsolidatedExportStatus(taskSeq, createConsolidatedExportFileName(), pollingConfig);
      })
      .finally(() => {
        if (!keepLoadingForPolling) {
          checkLoading(loading, false);
        }
      });
  };

  // 重大性檢核 popup
  const handleDialogConfirm = () => {
    setImportantDialog(false);
    // 確認後繼續執行跳轉
    if (confirmAction === "word") {
      navigate("report", { state: { companyName: itemObj?.companyName } });
    } else {
      // 不是 word 時也要開出選項畫面
      setTemplateDialog(true);
    }
  };

  // 重大性鑑別檢核
  const axios_checkImportantIndetificationItem = async (planSn) => {
    const res = await checkImportantIndetificationItem({ planSn });
    if (checkDpSuccess(res)) {
      let result = res?.data?.RespBody?.importanceList;
      return result?.length > 0; // 返回是否需要顯示對話框
    }
    return false;
  };

  // 產生報告書
  const exportWord = (rowData) => {
    setReportListObj([rowData]);
    rowData.companySeq = getValues("companySeq");
    setItemObj(rowData);
    setAction("report");
    setTab1Action("report");

    // 若有重大性鑑別，先調用 API 檢查
    if (rowData?.importanceIdentification === "Y") {
      axios_checkImportantIndetificationItem(rowData?.planSn).then((showDialog) => {
        if (showDialog) {
          // 如果需要顯示對話框，則開啟對話框
          setImportantDialog(true);
        } else {
          // 如果不需要對話框，直接跳轉
          navigate("report", { state: { companyName: rowData?.companyName } });
        }
      });
    } else {
      // 如果沒有重大性鑑別，直接跳轉
      navigate("report", { state: { companyName: rowData?.companyName } });
    }
  };

  // 前往儀表板
  const handleDashboardLink = (rowData) => {
    navigate("dashboard", {
      state: {
        companyName: rowData.companyName,
        companySeq: rowData.companySeq,
        placeName: rowData.placeName,
        caseSn: {
          year: rowData.year,
          planSn: rowData?.planSn,
          displayYear: rowData?.displayYear,
          displayCause: rowData?.displayCause,
        },
      },
    });
  };

  // 碳盤查清單
  const axios_getCarbonPlanList = (reqBody, readMore = false) => {
    checkLoading(loading);
    const params = Object.fromEntries(
      Object.entries(reqBody)
        .filter(([_, value]) => isNotBlank(value))
        .map(([key, value]) => [key, key === "planType" ? [value] : value]),
    );
    getCarbonPlanList(params)
      .then((res) => {
        if (checkDpSuccess(res)) {
          let data = res.data.RespBody.planList;
          setCreateButtonFlag(res.data?.RespBody?.createButtonFlag);
          // 把排程中的報告書統整
          setBatchPlanSnList((prev) => {
            const map = new Map();
            prev.forEach((item) => {
              map.set(item.planSn, item);
            });
            data.forEach((item) => {
              if (item.batchStatus === "P" || item.batchStatus === "L") {
                map.set(item.planSn, item);
              } else {
                map.delete(item.planSn);
              }
            });
            return Array.from(map.values());
          });

          if (data.length === 0) {
            if (!readMore) setRowData([]);
            return;
          }
          setLastDataSeq(data[data.length - 1].planSn);
          setRowData((prev) => (readMore ? [...prev, ...data] : [...data]));
        }
      })
      .finally(() => checkLoading(loading, false));
  };

  //查詢更多
  const btnReadMore = () => {
    axios_getCarbonPlanList({ ...buildSearchReqBody(), planSn: lastDataSeq }, true);
  };

  const checkKeyDown = (e) => {
    if (e.key === "Enter") e.preventDefault();
  };

  const actionBodyTemplate = (rowData, props) => {
    if (!rowData) return null;

    // 排程中
    if (rowData?.batchStatus === "P") {
      return (
        <Button
          tooltip={t("button.scheduled")}
          tooltipOptions={{ position: "top" }}
          rounded
          text
          icon="pi pi-spin pi-spinner"
          severity="secondary"
          className="p-button-icon-only"
        />
      );
    }
    // 失敗
    if (rowData?.batchStatus === "X") {
      return (
        <>
          {/* 備註 */}
          <Button
            tooltip={rowData?.batchMemo}
            tooltipOptions={{ position: "top" }}
            rounded
            text
            severity="secondary"
            className="p-button-icon-only text-red-300"
          >
            <FontAwesomeIcon icon="fa-solid fa-triangle-exclamation" />
          </Button>
          {/* 刪除 */}
          <Button
            tooltip={t("button.delete")}
            tooltipOptions={{ position: "top" }}
            rounded
            text
            severity="secondary"
            className="p-button-icon-only"
            onClick={() => {
              deleteItem(rowData);
            }}
            disabled={!isEditable}
          >
            <FontAwesomeIcon icon="fa-solid fa-trash" />
          </Button>
        </>
      );
    }
    // 成功
    return (
      <>
        {/* 詳細資料 */}
        <Button
          tooltip={t("button.detail")}
          tooltipOptions={{ position: "top" }}
          rounded
          text
          disabled={rowData?.batchStatus === "L"}
          severity="secondary"
          className="p-button-icon-only"
          onClick={() => {
            goItemPage(rowData, "detail");
          }}
        >
          <FontAwesomeIcon icon="fa-solid fa-eye" />
        </Button>
        {/* 清冊按鈕 - 根據權限控制 */}
        {getCurrentLocale() === "zh-TW" && (
          <Button
            tooltip={t("button.inventory")}
            tooltipOptions={{ position: "top" }}
            rounded
            text
            severity="secondary"
            className="p-button-icon-only"
            disabled={!hasTabPermission("inventory")}
            onClick={() => {
              setConfirmAction("export");
              handleExportItem(rowData);
            }}
          >
            <FontAwesomeIcon icon="fa-solid fa-file-export" />
          </Button>
        )}
        {/* 報告書按鈕 - 根據權限控制 */}
        <Button
          tooltip={t("button.report")}
          tooltipOptions={{ position: "top" }}
          rounded
          text
          severity="secondary"
          className="p-button-icon-only"
          disabled={!hasTabPermission("report")}
          onClick={() => {
            setConfirmAction("word");
            exportWord(rowData);
          }}
        >
          <FontAwesomeIcon icon="fa-solid fa-file-arrow-down" />
        </Button>
        {/* 儀表板 */}
        <Button
          icon="pi pi-chart-pie"
          tooltip={t("button.dashboard")}
          tooltipOptions={{ position: "top" }}
          rounded
          text
          severity="secondary"
          className="p-button-icon-only"
          onClick={() => {
            handleDashboardLink(rowData);
          }}
        />
        {/* 複製 */}
        <Button
          tooltip={t("copy")}
          tooltipOptions={{ position: "top" }}
          onClick={() => {
            if (!createButtonFlag) {
              setLimitDialog(true);
            } else {
              copyItem(rowData);
            }
          }}
          className="p-button-icon-only"
          rounded
          text
          severity="secondary"
          disabled={!isEditable || rowData?.batchStatus === "L"}
        >
          <FontAwesomeIcon icon="fa-solid fa-copy" />
        </Button>
        {/* 刪除 */}
        <Button
          tooltip={t("button.delete")}
          tooltipOptions={{ position: "top" }}
          rounded
          text
          severity="secondary"
          className="p-button-icon-only"
          onClick={() => {
            deleteItem(rowData);
          }}
          disabled={!isEditable || rowData?.batchStatus === "L"}
        >
          <FontAwesomeIcon icon="fa-solid fa-trash" />
        </Button>
      </>
    );
  };

  // 複製盤查計畫
  const confirmCopyPlan = () => {
    checkLoading(loading);
    copyPlanSn({
      year: encoder(planYearList, getValues("year")),
      planSn: itemObj?.planSn,
      dataFlag: getValues("dataFlag") ? "Y" : "N",
    })
      .then((res) => {
        if (checkDpSuccess(res)) {
          handleSuccessMessage(dispatch, t("button.copy") + " " + t("message.success"));
          axios_getCarbonPlanList(buildSearchReqBody());
          setCopyPlanDialog(false);
          setValue("year", "");
          setValue("dataFlag", false);
        }
      })
      .finally((fin) => {
        checkLoading(loading, false);
      });
  };

  // 流程圖下次不再顯示
  const updateUserInfo = (dontShow) => {
    const value = dontShow ? "Y" : "N";
    if (value !== state?.dontShowAgain) {
      updateFeUsers2Info({
        userDataList: [
          {
            refKey: "DONT_SHOW_AGAIN",
            refValue: value,
          },
        ],
      }).then((res) => {
        dispatchUser({
          type: "DONT_SHOW_AGAIN",
          payload: { dontShowAgain: value },
        });
      });
    }
  };

  // 新增按鈕 Column body
  const collapseButtonBody = (rowData) => {
    const rowKey = rowData.planSn;
    const isExpanded = expandedRows[rowKey];
    const list = rowData.placeName || [];

    if (list.length <= placeListLimit) return null; // 少於兩個不用按鈕

    return (
      <Button
        icon={isExpanded ? "pi pi-chevron-down" : "pi pi-chevron-right"}
        className="p-button-link p-0"
        style={{
          fontSize: "0.7rem",
          padding: "0.2rem",
          width: "1.2rem",
          height: "1.2rem",
        }}
        onClick={() =>
          setExpandedRows((prev) => ({
            ...prev,
            [rowKey]: !prev[rowKey],
          }))
        }
      />
    );
  };

  // 調整 renderWithCollapse 右側文字不再包含按鈕
  const renderWithCollapse = (rowData, key, field, textAlign = "left") => {
    const rowKey = rowData[key];
    const isExpanded = expandedRows[rowKey];
    const list = rowData[field] || []; // 也可以用 field 來控制顯示欄位
    const showList = isExpanded ? list : list.slice(0, placeListLimit);

    return (
      <div>
        {showList.map((item, idx) => (
          <div
            key={idx}
            style={{
              textAlign: textAlign,
              lineHeight: "1.5rem",
              minHeight: "1.5rem",
            }}
          >
            {item}
          </div>
        ))}
      </div>
    );
  };

  // 表格場所名稱
  const rawExpandBody = (rowData) => renderWithCollapse(rowData, "planSn", "placeName");

  // 刪除 popup 顯示場所名稱
  const placeNameField = (placeNames) => {
    // 確保 placeNames 永遠是陣列
    const namesArray = Array.isArray(placeNames) ? placeNames : [placeNames];

    if (!namesArray || namesArray.length === 0) return null;

    const showCount = 1; // 超過 1 個收合
    const displayList = delExpanded ? namesArray : namesArray.slice(0, showCount);
    const remaining = namesArray.length - showCount;

    const displayValue = displayList.join(", ");

    return (
      <span className="inline-flex items-center gap-1">
        <span>{displayValue}</span>
        {remaining > 0 && (
          <Button
            type="button"
            onClick={() => setDelExpanded(!delExpanded)}
            className="p-button-text"
            icon={delExpanded ? "pi pi-angle-up" : "pi pi-angle-down"}
            text
            size="small"
            style={{ height: "1.5rem", width: "0.2rem" }}
          />
        )}
      </span>
    );
  };

  // 送出查詢
  const onSubmit = () => {
    axios_getCarbonPlanList(buildSearchReqBody());
  };

  return (
    <>
      <div className="p-card bg-gray">
        <div className="p-card-body">
          <form onSubmit={handleSubmit(onSubmit)} onKeyDown={checkKeyDown} className="grid">
            {/* 組織名稱 */}
            <div className="col-12 lg:col-6">
              <label htmlFor="placeName" className="form-label required">
                {t("organName")}
              </label>
              <Controller
                name="companySeq"
                control={control}
                rules={{
                  required: { value: true, message: t("validation.required") },
                }}
                render={({ field, fieldState }) => (
                  <Dropdown
                    filter
                    disabled={getCompanyType() === "A"}
                    appendTo={"self"}
                    optionLabel="companyName"
                    optionValue="companySeq"
                    value={field.value}
                    virtualScrollerOptions={{ itemSize: 40 }}
                    defaultValue={""}
                    placeholder={t("plz_chs")}
                    name="companySeq"
                    control={control}
                    options={companyPlaceList}
                    className={`w-full ` + classNames({ "p-invalid": fieldState.error })}
                    onChange={(event) => {
                      const companySeq = event.value;
                      const reqBody = { companySeq };

                      reset(reqBody);
                      field.onChange(companySeq);
                      setFilterParams((prev) => ({ ...prev, companySeq }));

                      const selectedCompany = companyPlaceList?.find((item) => item.companySeq === companySeq);
                      setPlaceList(selectedCompany?.placeList);
                      setCreateButtonFlag(selectedCompany?.createButtonFlag);

                      axios_getCarbonPlanList(reqBody);
                    }}
                  />
                )}
              />
              {getFormErrorMessage(errors, "companySeq")}
            </div>
            {/* 場所名稱 */}
            <div className="col-12 lg:col-6">
              <label htmlFor="placeName" className="form-label">
                {t("place_name")}
              </label>
              <Controller
                name="placeSeq"
                control={control}
                render={({ field, fieldState }) => (
                  <Dropdown
                    filter
                    showClear
                    appendTo={"self"}
                    optionLabel="placeName"
                    optionValue="placeSeq"
                    disabled={!(placeList ?? []).length > 0}
                    value={field.value}
                    virtualScrollerOptions={{ itemSize: 40 }}
                    defaultValue={""}
                    placeholder={t("plz_chs_all")}
                    name="placeSeq"
                    control={control}
                    options={placeList}
                    className={`w-full ` + classNames({ "p-invalid": fieldState.error })}
                    onChange={(event) => {
                      field.onChange(event.value);
                      setFilterParams((prev) => ({
                        ...prev,
                        placeSeq: event.value,
                      }));
                    }}
                  />
                )}
              />
              {getFormErrorMessage(errors, "placeSeq")}
            </div>
            {/* 清冊類型 */}
            <div className="col-12 lg:col-6">
              <label htmlFor="planType" className="form-label">
                {t("planType")}
              </label>
              <Controller
                name="planType"
                control={control}
                render={({ field, fieldState }) => (
                  <Dropdown
                    filter
                    showClear
                    appendTo={"self"}
                    optionLabel="subitemName"
                    optionValue="subitemNo"
                    value={field.value}
                    virtualScrollerOptions={{ itemSize: 40 }}
                    defaultValue={""}
                    placeholder={t("plz_chs_all")}
                    name="planType"
                    control={control}
                    options={planTypeList}
                    className={`w-full ` + classNames({ "p-invalid": fieldState.error })}
                    onChange={(event) => {
                      field.onChange(event.value);
                      setFilterParams((prev) => ({
                        ...prev,
                        planType: event.value,
                      }));
                    }}
                  />
                )}
              />
              {getFormErrorMessage(errors, "planType")}
            </div>
            {/* 盤查年度起迄 */}
            <div className="col-12 lg:col-6">
              <label htmlFor="placeName" className="form-label">
                {t("startYear_endYear_roc")}
              </label>
              <div className="col-date-picker">
                <Controller
                  name="startYear"
                  control={control}
                  render={({ field, fieldState }) => (
                    <Dropdown
                      showClear
                      appendTo={"self"}
                      optionLabel="subitemName"
                      optionValue="subitemNo"
                      value={field.value}
                      virtualScrollerOptions={{ itemSize: 40 }}
                      defaultValue={""}
                      placeholder={t("plz_chs_all")}
                      name="startYear"
                      control={control}
                      options={planYearList}
                      className={classNames({ "p-invalid": fieldState.error })}
                      onChange={(event) => {
                        field.onChange(event.value);
                        setFilterParams((prev) => ({
                          ...prev,
                          startYear: event.value,
                        }));
                      }}
                    />
                  )}
                />
                {getFormErrorMessage(errors, "startYear")}
                <Controller
                  name="endYear"
                  control={control}
                  render={({ field, fieldState }) => (
                    <Dropdown
                      showClear
                      appendTo={"self"}
                      optionLabel="subitemName"
                      optionValue="subitemNo"
                      value={field.value}
                      virtualScrollerOptions={{ itemSize: 40 }}
                      defaultValue={""}
                      placeholder={t("plz_chs_all")}
                      name="endYear"
                      control={control}
                      options={planYearList}
                      className={classNames({ "p-invalid": fieldState.error })}
                      onChange={(event) => {
                        field.onChange(event.value);
                        setFilterParams((prev) => ({
                          ...prev,
                          endYear: event.value,
                        }));
                      }}
                    />
                  )}
                />
                {getFormErrorMessage(errors, "endYear")}
              </div>
            </div>
            <div className="col-12 gap-2 flex-all-center">
              <Button type="submit" label={t("button.query")} />
              <Button
                disabled={!isValid || !isEditable}
                outlined
                type="button"
                onClick={() => {
                  if (!createButtonFlag) {
                    setLimitDialog(true);
                  } else {
                    goItemPage({ companyName: itemObj?.companyName }, "create");
                  }
                }}
                label={t("button.create")}
              />
            </div>
          </form>
        </div>
      </div>
      <div className="p-card">
        <div className="p-card-body">
          <div
            className="col-12"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            {/* 合併清冊 */}
            <Button
              disabled={!hasTabPermission("inventory")}
              onClick={() => {
                setConsolidatedDialog(true);
              }}
            >
              {t("button.consolidatedList")}
            </Button>
            {/* 盤查流程圖 */}
            <Button
              tooltip={t("inventoryPlanFlow.title")}
              tooltipOptions={{ position: "top" }}
              rounded
              text
              severity="secondary"
              className="p-button-icon-only"
              onClick={() => {
                setFlowDialog(true);
              }}
            >
              <FontAwesomeIcon icon="fa-solid fa-compass" />
            </Button>
          </div>
          <DataTable
            stripedRows
            className="white-data-table hover-highlight no-shadow no-checkbox-all"
            tableStyle={{ minWidth: "55rem" }}
            value={rowData}
            footer={
              rowData.length > 0 && (
                <PrimeTableFooter rowDataList={rowData} isShowMore={true} btnReadMore={btnReadMore} />
              )
            }
            emptyMessage={<NoInfo panel="table" />}
          >
            {cols?.map((col, index) => {
              return <Column key={index} field={col.field} header={col.header} body={col.body} style={col.style} />;
            })}
            <Column
              style={{ width: "auto" }}
              body={actionBodyTemplate}
              header={t("action")}
              frozen
              alignFrozen="right"
            />
          </DataTable>
        </div>
      </div>

      {/* 刪除 */}
      <PrimeConfirmDialog
        visible={delDialog}
        onClose={() => {
          setDelDialog(false);
        }}
        onConfirm={() => {
          confirmDel();
        }}
        title={t("button.delete")}
        bodyTemplate={
          <>
            <div className="form-label">
              {t("queryYear")}: {delObj?.displayYear}
            </div>
            <div className="form-label">
              {t("place")}: {placeNameField(delObj?.placeName)}
            </div>
          </>
        }
      />

      {/* 盤查計劃尚未完成，是否執行該操作？ */}
      <PrimeConfirmDialog
        visible={importantDialog}
        onClose={() => {
          setImportantDialog(false);
        }}
        onConfirm={() => {
          handleDialogConfirm();
        }}
        title={t("hint")}
        bodyTemplate={t("cfm_plan_not_complete")}
      />

      {/* 合併清冊 */}
      <PrimeDialog
        scrollByBody={false}
        visible={consolidatedDialog}
        onClose={() => {
          setConsolidatedDialog(false);
          setSelPlan(null);
        }}
        disabledConfirm={!selPlan?.length > 0}
        onConfirm={() => {
          exportMultiItem();
        }}
        title={t("button.consolidatedList")}
        size="md"
        bodyTemplate={
          <ConsolidateList
            defaultCompanySeq={getValues("companySeq")}
            setSelPlan={setSelPlan}
            selPlan={selPlan}
            planYearList={planYearList}
          />
        }
      />

      {/* 複製 */}
      <PrimeDialog
        size="sm"
        visible={copyPlanDialog}
        onClose={() => {
          setCopyPlanDialog(false);
          setValue("year", "");
          setValue("dataFlag", false);
        }}
        onConfirm={() => {
          confirmCopyPlan();
        }}
        title={t("button.copy")}
        disabledConfirm={!watch("year")}
        bodyTemplate={<AddCopyPlanSn control={control} errors={errors} planObj={itemObj} planYearList={planYearList} />}
      />

      {/* 匯出EXCEL清冊 */}
      <PrimeDialog
        size="sm"
        visible={templateDialog}
        onClose={() => {
          setTemplateDialog(false);
          setSelectedTemplate(null);
        }}
        onConfirm={() => {
          if (selectedTemplate) {
            exportItem(itemObj, selectedTemplate);
            setTemplateDialog(false);
            setSelectedTemplate(null);
          }
        }}
        title={t("選擇匯出的範本")}
        disabledConfirm={!selectedTemplate}
        bodyTemplate={
          itemObj?.planType === "0" || itemObj?.planType === "1"
            ? commonExportBodyTemplate()
            : industrialExportBodyTemplate(itemObj?.planTypeName)
        }
      />

      {/* 流程圖模態框 */}
      <ImageLocaleModal
        visible={flowDialog}
        checked={flowCheck}
        onHide={() => setFlowDialog(false)}
        onDontShowAgain={(dontShow) => {
          updateUserInfo(dontShow);
        }}
        step={flowStep}
      />

      {/* 盤查上限 */}
      <PrimeDialog
        visible={limitDialog}
        isShowConfBtn={false}
        onClose={() => {
          setLimitDialog(false);
        }}
        title={t("button.create")}
        bodyTemplate={<>{t("createCountLimitReachedTip")}</>}
      />
    </>
  );
}
